module.exports = __webpack_public_path__ + "img/emailsms_gmail2.d03a2996.jpg";